import { enableProdMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { provideHttpClient, withXhr, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/providers/auth-interceptor.service';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app/app.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(FormsModule, ReactiveFormsModule),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
        { provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: { hideIcon: true } },
        provideNativeDateAdapter()
    ]
})
  .catch(err => console.error(err));
